import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { ENDPOINTS } from 'features/daily-plan/constants';
import { useFetchWithStatusV2 } from 'hooks/fetchWithStatus';
import { UIStatus } from 'UI/constants/status';

import { Comment } from '../Comment';

import { Container, LoaderContainer } from './CommentTimeline.styled';

const DAILY_PLAN_TASK_MAX_COMMENTS =
  window.GPAC_ENV?.DAILY_PLAN_TASK_MAX_COMMENTS ??
  process.env.REACT_APP_DAILY_PLAN_TASK_MAX_COMMENTS ??
  20;

export const CommentTimeline = ({ taskId }) => {
  const { state } = useFetchWithStatusV2({
    endpoint: `${ENDPOINTS.comments.replace(
      ':id',
      taskId
    )}?perPage=${DAILY_PLAN_TASK_MAX_COMMENTS}`,
    initialStatus: UIStatus.Default
  });

  const comments = state?.results?.data ?? [];

  return (
    <Container>
      {state.status === UIStatus.Loading ? (
        <LoaderContainer>
          <CircularProgress />
        </LoaderContainer>
      ) : (
        comments.map(comment => (
          <Comment
            key={comment.id}
            body={comment.body}
            date={comment.createdAt}
            userName={comment.createdByName}
          />
        ))
      )}
    </Container>
  );
};
